<template>
  <div class="layout k-main">
    <layoutHeader v-if="info.flag" :info="info"></layoutHeader>
    <el-container class="k-container">
      <layoutAside v-if="info.flag" :info="info"></layoutAside>
      <div class="k-container-main">
        <router-view v-if="info.flag" :info="info"></router-view>
      </div>
    </el-container>
  </div>
</template>


<script>
import layoutAside from './aside/aside'
import layoutHeader from './header/header'

export default {
  name: 'layout',
  components: {
    layoutHeader,
    layoutAside
  },
  data() {
    return {
      info: {
        flag: false,
        views: {
          isManager: '',
          isSupper: '',
          routes: [],
          menus: [],
          actions: [],
          user: []
        },
        menus: [],
        size: 'mini',
        changePassFormVisiable: false,
        indexClic: '0',
        clickMenus: [],
        defaultUrl: '/',
        defaultOpeneds: [],
        changePassForm: {
          password: '',
          newpass: '',
          repass: ''
        },
        rules: {
          password: [
            {
              required: true,
              message: '请填写当前密码',
              trigger: ['change', 'blur']
            }
          ],
          newpass: [
            {
              required: true,
              message: '请填写新密码',
              trigger: ['change', 'blur']
            }
          ],
          repass: [
            {
              required: true,
              message: '请再次填写新密码',
              trigger: ['change', 'blur']
            },
            {
              validator: function(rule, value, callback) {
                if (value !== this.info.changePassForm.newpass) {
                  callback(new Error('两次输入密码不一致!'))
                } else {
                  callback()
                }
              }.bind(this),
              trigger: ['change', 'blur']
            }
          ]
        }
      }
    }
  },
  mounted: function() {
    this.getMenuList()
  },
  watch: {},
  methods: {
    isAuthAction: function(action) {
      if (this.info.views.isSupper) {
        return true
      }

      action = action
        .split('/')
        .join(':')
        .toLowerCase()

      return this.info.views.actions.indexOf(action) > -1
    },
    getMenuList: function() {
      this.$api.http.get('index/getmenulist').then(res => {
        if (res && res.code == 0) {
          this.info.views = res.data
          var path = this.$route.path
          if (path == '/') {
            this.info.clickMenus = res.data.menus[0].children
            this.info.indexClic = 0
          } else {
            this.info.views.menus.forEach(
              function(item, index) {
                var urls = item.children.map(x => x['url'])
                var ind = urls.indexOf(path)
                if (ind != -1) {
                  this.info.clickMenus = this.info.views.menus[index].children
                  this.info.indexClic = index
                }
              }.bind(this)
            )
          }
          this.info.flag = true
        }
      })
    }
  }
}
</script>
<style lang="scss">
.k-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  .k-container {
    position: relative;
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-direction: row;
    .k-container-main {
      position: relative;
      flex: 1;
      overflow: auto;
      background: #f8f8f7;
    }
  }
}
</style>